import React, { FC } from 'react';
import { motion } from 'framer-motion';
import { usePathname } from 'next/navigation';
import s from './Layout.module.css';
import { LayoutProps } from '@/types/model';
import { Footer, Header, Contact, Decorations } from '@/components';

const HIDE_HEADER_PATHS = [
  '/aviso-de-privacidad',
  '/aviso-programa-de-referidos',
  '/en/aviso-de-privacidad',
  '/en/aviso-programa-de-referidos'
];
const HIDE_CONTACT_PATHS = [
  '/aviso-de-privacidad',
  '/aviso-programa-de-referidos',
  '/avance-de-obra',
  '/en/aviso-de-privacidad',
  '/en/aviso-programa-de-referidos',
  '/en/avance-de-obra'
];

const Layout: FC<LayoutProps> = ({ menu, children, footer: footer_data, previewMode }) => {
  const pathname = usePathname();

  return (
    <motion.main className={s.layout}>
      {previewMode && (
        <div className={s.layout__previewBanner}>
          Estás viendo una vista previa sin publicar.
          <a href={`/api/preview/disable?url=${encodeURIComponent(pathname)}`}>
            Salir de la vista previa
          </a>
        </div>
      )}
      {menu && !HIDE_HEADER_PATHS.includes(pathname) && <Header {...menu} />}
      <Decorations />

      <motion.article className={s.layout__main}>{children}</motion.article>

      {!HIDE_CONTACT_PATHS.includes(pathname) && <Contact />}

      {footer_data && <Footer {...footer_data} />}
    </motion.main>
  );
};

export default Layout;
